const isDevelopment = process.env.NODE_ENV === 'development';

export const API_CONFIG = {
  BASE_URL: isDevelopment ? 'http://localhost:3001' : 'https://api.txtifier.com',
  V1_BASE_URL: isDevelopment ? 'http://localhost:3001/v1' : 'https://api.txtifier.com/v1',
  ADMIN_BASE_URL: isDevelopment ? 'http://localhost:3001/api/admin' : 'https://api.txtifier.com/api/admin',
  AUTH_BASE_URL: isDevelopment ? 'http://localhost:3001/api/auth' : 'https://api.txtifier.com/api/auth'
};

export const getApiUrl = (endpoint) => {
  if (endpoint.startsWith('/v1/')) {
    return `${API_CONFIG.V1_BASE_URL}${endpoint.substring(3)}`;
  }
  if (endpoint.startsWith('/api/admin/')) {
    return `${API_CONFIG.ADMIN_BASE_URL}${endpoint.substring(10)}`;
  }
  if (endpoint.startsWith('/api/auth/')) {
    return `${API_CONFIG.AUTH_BASE_URL}${endpoint.substring(9)}`;
  }
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};